var LangSelector = (function () {
    function LangSelector() {
        this.langSelector = document.getElementById("langSelector");
        this.selectorBtn = document.getElementById("selectorBtn");
        //this.selectedLang = document.getElementById("selectedLang");
        this.dropdownMenu = document.getElementById("dropdownMenu");
        this.options = this.dropdownMenu.querySelectorAll(".option");
        //this.flagImg = this.selectorBtn.querySelector("img");
    }

    LangSelector.prototype.init = function () {
        var self = this;

        // Toggle dropdown on click
        this.langSelector.addEventListener("click", function () {
            self.langSelector.classList.toggle("open");
            const isOpen = self.langSelector.classList.contains("open");
            self.selectorBtn.setAttribute("aria-expanded", isOpen);
        });

        // Handle keyboard toggle (Enter or Space)
        this.langSelector.addEventListener("keydown", function (e) {
            const isEnter = e.key === "Enter" || e.keyCode === 13;
            const isSpace = e.key === " " || e.keyCode === 32;
            if (isEnter || isSpace) {
                e.preventDefault(); // Prevent scroll on Space
                self.langSelector.classList.toggle("open");
                const isOpen = self.langSelector.classList.contains("open");
                self.selectorBtn.setAttribute("aria-expanded", isOpen);
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", function (e) {
            if (!self.langSelector.contains(e.target)) {
                self.langSelector.classList.remove("open");
                self.selectorBtn.setAttribute("aria-expanded", "false");
            }
        });

        // Handle Escape key on options to close and return focus to langSelector
        this.options.forEach(function (option) {
            option.addEventListener("keydown", function (e) {
                if (e.key === "Escape" || e.keyCode === 27) {
                    e.preventDefault();
                    self.langSelector.classList.remove("open");
                    self.selectorBtn.setAttribute("aria-expanded", "false");
                    self.langSelector.focus();
                }
                if (e.key === "Enter" || e.keyCode === 13) {
                    // Simulate click
                    option.click();
                }
            });

            // Close dropdown on Tab from last item
            option.addEventListener("keydown", function (e) {
                if ((e.key === "Tab" || e.keyCode === 9) && !e.shiftKey &&
                    option === self.options[self.options.length - 1]) {
                    self.langSelector.classList.remove("open");
                    self.selectorBtn.setAttribute("aria-expanded", "false");
                }
            });
        });

        // Handle language selection
        this.options.forEach(function (option) {
            option.addEventListener("click", function () {
                self.options.forEach(function (opt) {
                    opt.classList.remove("active");
                    opt.setAttribute("aria-selected", "false");
                });

                option.classList.add("active");
                option.setAttribute("aria-selected", "true");

                // Get new lang and flag from inside the option
                //var newLang = option.getAttribute("data-lang");
                //var newFlag = option.querySelector("img").src;

                //// Update selector button
                //self.selectedLang.textContent = newLang;
                //self.flagImg.src = newFlag;

                // Visual styling
                self.selectorBtn.classList.add("active");

                // Close dropdown
                self.langSelector.classList.remove("open");
                self.selectorBtn.setAttribute("aria-expanded", "false");
                self.langSelector.focus();
            });
        });
    };

    return LangSelector;
})();

// Init on document ready
if (document.getElementById("langSelector")) {
    var langSelector = new LangSelector();
    langSelector.init();
}

analytics.eventConfig.push({
    "target": ".language-selector",
    "codeId": "lsw",
    "events": [
        {
            "eventTarget": "a",
            "eventType": "click",
            "tags": {
                "event": "navigation",
                "componentName": "language switcher",
                "componentId": "lsw",
                "eventType": "language switcher internal navigation click",
                "elementType": "language switcher",
                "elementText": "",
                "destinationUrl": "",
                "parentName": ""
            }
        }
    ]
});
